import { render, staticRenderFns } from "./SuggestedPOReport.vue?vue&type=template&id=24fc1cb9&scoped=true"
import script from "./SuggestedPOReport.vue?vue&type=script&lang=js"
export * from "./SuggestedPOReport.vue?vue&type=script&lang=js"
import style0 from "./SuggestedPOReport.vue?vue&type=style&index=0&id=24fc1cb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc1cb9",
  null
  
)

export default component.exports